import { ENTITY_NAME as USERS_ENTITY_NAME } from '@esentai/core/features/users/consts';

export const USERS_RETRY_FETCH = `${USERS_ENTITY_NAME}/RETRY_FETCH`;
